import React, { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import "./menu.css";
import {
  IoChevronDownOutline,
  IoChevronBackOutline,
  IoChevronForwardOutline,
  IoCloseOutline,
  IoLogOutOutline,
  IoPeopleOutline,
  IoTimeOutline,
  IoSettingsOutline,
  IoBodyOutline,
  IoBookmarksOutline,
  IoLocationOutline,
  IoCubeOutline,
  IoLibraryOutline,
  IoDocumentTextOutline,
  IoGridOutline,
} from "react-icons/io5";
import { GiMoneyStack } from "react-icons/gi";

import { FaNetworkWired } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import LogoText from "../../../media/logo_text.webp";
import LogoShort from "../../../media/logo_short.svg";
import BurgerMenu from "../../../media/burger_menu.png";
import GetData from "../../../services/getData";
import LanguageSwitcher from "../../ui/LanguageSwitcher";
import { useMediaQuery } from "../../../hooks/useMediaQuery";
function Menu({ client, isCollapsed, onToggleCollapse }) {
  const { t } = useTranslation("menu");
  const location = useLocation();
  const [expandedMenus, setExpandedMenus] = useState({});
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  // На мобильных сайдбар — обычное выезжающее меню, свёрнутый режим отключён
  const isMobile = useMediaQuery("(max-width: 991px)");
  const collapsed = isCollapsed && !isMobile;

  // Пункты меню разбиты на группы (как в эталонном макете).
  // Записи с groupKey — заголовки групп, остальное — пункты навигации.
  const menuItems = [
    // Общий ИИ консультант временно скрыт
    // {
    //   labelKey: "aiConsultant",
    //   path: "/ai-chat",
    //   icon: <IoChatbubbleEllipsesOutline />,
    // },
    {
      key: "summary",
      labelKey: "summary",
      icon: <IoGridOutline />,
      path: "/",
    },

    { key: "group-patients", groupKey: "groups.patients" },
    {
      key: "schedule",
      labelKey: "schedule",
      icon: <IoTimeOutline />,
      path: "/schedule/",
    },
    {
      key: "patients",
      labelKey: "patients",
      icon: <IoPeopleOutline />,
      path: "/patient/",
    },

    { key: "group-admin", groupKey: "groups.admin" },
    {
      key: "services",
      labelKey: "services",
      path: "/services/",
      icon: <IoBodyOutline />,
    },
    {
      key: "warehouse",
      labelKey: "warehouse.title",
      icon: <IoCubeOutline />,
      submenu: [
        { key: "warehouse-list", labelKey: "warehouse.list", path: "/warehouse/" },
        { key: "warehouse-units", labelKey: "warehouse.units", path: "/warehouse/units/" },
        { key: "warehouse-logs", labelKey: "warehouse.logs", path: "/warehouse/logs/" },
      ],
    },
    {
      key: "templates",
      labelKey: "templates.title",
      icon: <IoBookmarksOutline />,
      submenu: [
        { key: "templates-treatment-plans", labelKey: "templates.treatmentPlans", path: "/templates/treatment_plans/" },
        { key: "templates-recommendations", labelKey: "templates.recommendations", path: "/templates/recommendation/" },
      ],
    },
    {
      key: "finance",
      labelKey: "finance.title",
      icon: <GiMoneyStack />,
      submenu: [
        { key: "finance-accounts", labelKey: "finance.accounts", path: "/finance/accounts/" },
        { key: "finance-transactions", labelKey: "finance.transactions", path: "/finance/transaction_history/" },
      ],
    },
    {
      key: "knowledge-base",
      labelKey: "knowledgeBase",
      path: "/knowledge_base",
      icon: <IoLibraryOutline />,
    },

    { key: "group-settings", groupKey: "groups.settings" },
    {
      key: "staff",
      labelKey: "staff",
      icon: <FaNetworkWired />,
      path: "/staff/",
    },
    {
      key: "clinics",
      labelKey: "clinics",
      path: "/contacts",
      icon: <IoLocationOutline />,
    },
    {
      key: "instructions",
      labelKey: "instructions.title",
      icon: <IoDocumentTextOutline />,
      submenu: [
        { key: "instructions-plan", labelKey: "instructions.plan", path: "/instructions/plan/" },
        { key: "instructions-appointments", labelKey: "instructions.appointments", path: "/instructions/appointments/" },
        { key: "instructions-recommendations", labelKey: "instructions.recommendations", path: "/instructions/recommendations/" },
        { key: "instructions-services", labelKey: "instructions.services", path: "/instructions/services/" },
      ],
    },
    {
      key: "settings",
      labelKey: "settings.title",
      icon: <IoSettingsOutline />,
      submenu: [
        { key: "settings-logs", labelKey: "settings.logs", path: "/settings/logs/" },
        { key: "settings-integrations", labelKey: "settings.integrations", path: "/settings/integrations/" },
      ],
    },
  ];

  // Функция для проверки активного пункта меню
  const isMenuItemActive = (item) => {
    if (item.path === "/" && location.pathname === "/") {
      return true;
    }

    if (item.path && location.pathname === item.path) {
      return true;
    }

    if (item.path) {
      const base = item.path.replace(/\/$/, "");
      if (base && location.pathname.startsWith(base + "/")) {
        return true;
      }
    }

    if (item.submenu) {
      return item.submenu.some((subItem) => subItem.path === location.pathname);
    }

    return false;
  };

  // Функция для получения активного имени меню
  // (getActiveMenuName не используется — удалено)

  const toggleSubmenu = (menuKey) => {
    setExpandedMenus((prev) => ({
      ...prev,
      [menuKey]: !prev[menuKey],
    }));
  };

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  // При возврате на десктоп мобильное меню всегда закрыто
  useEffect(() => {
    if (!isMobile) {
      setIsMenuOpen(false);
    }
  }, [isMobile]);

  // Пока открыта мобильная панель — блокируем прокрутку страницы
  useEffect(() => {
    if (!isMobile || !isMenuOpen) {
      return undefined;
    }

    const previous = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = previous;
    };
  }, [isMobile, isMenuOpen]);

  const handleLogout = async (e) => {
    e.preventDefault();
    try {
      await GetData({
        module: "auth",
        block: "auth",
        action: "logout",
      });
    } finally {
      closeMenu();
      window.location.href = "/";
    }
  };

  const handleMenuClick = (item) => {
    if (item.submenu) {
      // В свёрнутом виде сначала раскрываем сайдбар и открываем подменю
      if (collapsed) {
        setExpandedMenus((prev) => ({ ...prev, [item.key]: true }));
        onToggleCollapse?.();
        return;
      }
      toggleSubmenu(item.key);
    }
    // Навигация будет обрабатываться через Link
  };

  const collapseLabel = collapsed ? t("collapse.show") : t("collapse.hide");

  return (
    <div className={`menu-container ${isMenuOpen ? "active" : ""} ${collapsed ? "collapsed" : ""}`}>
      <div className="clinic-header">
        <a
          href="/"
          className="clinic-header-logo"
          title={t("user.goHome")}>
          <img
            src={LogoText}
            className="clinic-header-logo_text"
            alt={t("user.logoAlt")}
          />
          <img
            src={LogoShort}
            className="clinic-header-logo_short"
            alt={t("user.logoAlt")}
          />
        </a>
        <button
          type="button"
          className="clinic-header-burger"
          onClick={toggleMenu}
          aria-label={t("user.burgerAlt")}
          aria-expanded={isMenuOpen}>
          {isMenuOpen ? (
            <IoCloseOutline />
          ) : (
            <img src={BurgerMenu} alt={t("user.burgerAlt")} />
          )}
        </button>
      </div>
      <div className="menu-block">
        <nav className="menu-nav">
          <ul className="menu-list">
            {menuItems.map((item) =>
              item.groupKey ? (
                <li key={item.key} className="menu-group-label">
                  {t(item.groupKey)}
                </li>
              ) : (
                <li key={item.key} className="menu-parent-item">
                {item.path ? (
                  <Link
                    to={item.path}
                    className={`menu-item ${isMenuItemActive(item) ? "active" : ""}`}
                    title={collapsed ? t(item.labelKey) : undefined}
                    onClick={closeMenu}>
                    <div className="menu-item-content">
                      {item.icon && (
                        <span className="menu-icon">{item.icon}</span>
                      )}
                      <span className="menu-label">{t(item.labelKey)}</span>
                    </div>
                  </Link>
                ) : (
                  <div
                    className={`menu-item ${isMenuItemActive(item) ? "active" : ""} ${item.submenu ? "has-submenu" : ""}`}
                    title={collapsed ? t(item.labelKey) : undefined}
                    onClick={() => handleMenuClick(item)}>
                    <div className="menu-item-content">
                      {item.icon && (
                        <span className="menu-icon">{item.icon}</span>
                      )}
                      <span className="menu-label">{t(item.labelKey)}</span>
                    </div>
                    {item.submenu && (
                      <span
                        className={`submenu-arrow ${expandedMenus[item.key] ? "expanded" : ""}`}>
                        <IoChevronDownOutline />
                      </span>
                    )}
                  </div>
                )}

                {item.submenu && expandedMenus[item.key] && (
                  <ul className="submenu">
                    {item.submenu.map((subItem) => (
                      <li key={subItem.key}>
                        <Link
                          to={subItem.path}
                          className={`submenu-item ${
                            location.pathname === subItem.path ? "active" : ""
                          }`}
                          onClick={closeMenu}>
                          {t(subItem.labelKey)}
                        </Link>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
              ),
            )}
          </ul>
        </nav>

        {/* НИЖНИЙ БЛОК: сворачивание, язык, пользователь */}
        <div className="menu-footer">
          <button
            type="button"
            className="menu-footer-row menu-collapse-btn"
            onClick={onToggleCollapse}
            title={collapseLabel}
            aria-label={collapseLabel}
            aria-expanded={!collapsed}>
            <span className="menu-footer-icon">
              {collapsed ? <IoChevronForwardOutline /> : <IoChevronBackOutline />}
            </span>
            <span className="menu-collapse-label">{collapseLabel}</span>
          </button>

          <div className="menu-footer-row menu-language-row">
            <LanguageSwitcher
              className="menu-language-switcher"
              variant="pills"
              withGlobe
            />
          </div>

          {client?.user?.id != null && (
            <button
              type="button"
              className="menu-item menu-logout-btn"
              onClick={handleLogout}
              title={t("user.logout")}>
              <span className="menu-item-content">
                <span className="menu-icon">
                  <IoLogOutOutline />
                </span>
                <span className="menu-label">{t("user.logout")}</span>
              </span>
            </button>
          )}
        </div>
      </div>

      {/* Затемнение под мобильной панелью: клик закрывает меню */}
      <div className="menu-overlay" onClick={closeMenu} aria-hidden="true" />
    </div>
  );
}

export default Menu;
